export type FeatureFlag = (typeof featureFlags)[number]

export const featureFlags = [
  'yp2395AbTestsDivideTraffic',
  'yp2798GamOrderRetargetingDealsDeliveries',
  'yp2827ControlingRefreshParamsOnAdUnitLevel',
] as const
